import { cn } from '@gestao/ui'

import { textLinkClasses } from '../../components/text-link'

/**
 * Links de texto das telas de acesso ("Esqueci minha senha", "Voltar para o login"): o mesmo
 * desenho do link de texto, com alvo de pelo menos 24 px de altura (D3) e 40 px no celular.
 */
export const authLinkClasses = cn(
  textLinkClasses,
  'inline-flex min-h-6 items-center max-sm:min-h-10',
)
